import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useToast } from "@/hooks/useToast";
import { ArrowLeft, QrCode, Package } from "lucide-react";

const CajeroModePage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { toast } = useToast();

  // Verificar que el usuario tenga permisos de cajero
  useEffect(() => {
    if (user && !["Cajero", "Admin"].includes(user.roles?.[0] || "")) {
      toast({
        title: "Acceso denegado",
        description: "No tienes permisos para acceder al modo cajero.",
        variant: "destructive",
      });
      navigate("/unauthorized");
    }
  }, [user, navigate, toast]);



  // Mostrar loading mientras se verifica el usuario
  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex items-center gap-2">
          <span>Cargando...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6 max-w-4xl">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/dashboard")}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Volver
            </Button>
            <div>
              <h1 className="text-2xl font-bold">Modo Cajero</h1>
              <p className="text-muted-foreground">Sistema de entrega por QR</p>
            </div>
          </div>


        </div>
      </div>

      {/* Información del cajero */}
      <Card className="mb-6">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Cajero Actual</p>
              <p className="font-medium">
                {user?.nombre} {user?.apellido}
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-muted-foreground">Rol</p>
              <p className="font-medium">{user?.roles?.[0]}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Opciones de cajero */}
      <Card className="mb-6">
        <CardHeader>
          <CardTitle>Opciones de Cajero</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Button
              variant="outline"
              className="h-auto p-4 flex flex-col items-center gap-2"
              onClick={() => navigate("/cajero/anonymous-qr")}
            >
              <QrCode className="h-6 w-6" />
              <div className="text-center">
                <div className="font-medium">Escáner QR Anónimo</div>
                <div className="text-xs text-muted-foreground">
                  Escanear pedidos de clientes anónimos
                </div>
              </div>
            </Button>
            <Button
              variant="outline"
              className="h-auto p-4 flex flex-col items-center gap-2"
              onClick={() => navigate("/cajero/qr-scanner")}
            >
              <Package className="h-6 w-6" />
              <div className="text-center">
                <div className="font-medium">Escáner QR Estudiantes</div>
                <div className="text-xs text-muted-foreground">
                  Sistema de créditos estudiantiles
                </div>
              </div>
            </Button>
          </div>
        </CardContent>
      </Card>




    </div>
  );
};

export default CajeroModePage;
